const abTestingApi = ({ abTesting }) => ({
  abTesting: {
    trackEvent: abTesting.trackEvent,
    updateVariant: abTesting.updateVariant,
  },
})

// eslint-disable-next-line @exodus/export-default/named
export default {
  id: 'abTestingApi',
  type: 'api',
  factory: abTestingApi,
  dependencies: ['abTesting'],
}
